export default __webpack_public_path__ + "static/media/gc_p.cdc77c6e.png";